module.exports = __webpack_public_path__ + "img/serverBanner.6e783b73.png";